// #region imports

// --- Angular
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

// --- 3rd Party
import { Observable, Subscription } from 'rxjs';

// --- HS Code
import { AppToastService } from '../services/app-toast.service';
import { ToastModel } from '../../models';

// #endregion

@Component({
  selector: 'hs-app-toast',
  templateUrl: './app-toast.component.html',
  styleUrls: ['./app-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppToastComponent implements OnInit {
  toasts$: Observable<ToastModel[]>;
  toastSubscription: Subscription;

  constructor(private toastService: AppToastService) {
  }

  ngOnInit() {
    this.toasts$ = this.toastService.toasts$;
  }

  hide(toast: ToastModel) {
    this.toastService.remove(toast);
  }
}
